// import { useState } from "react";
// import { MdClose, MdSend } from "react-icons/md";
// import {
//   createNotification,
//   updateNotification,
// } from "api/pushNotification.api";
// import { InputField, TextareaField } from ".././FormFields";

// export default function BulkNotificationForm({
//   initialData,
//   onSubmit,
//   onClose,
// }) {
//   const [form, setForm] = useState({
//     title: initialData?.title || "",
//     message: initialData?.message || "",
//     send_type: initialData?.send_type || "all",
//     fcm_token: initialData?.fcm_token || "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async () => {
//     setError("");
//     if (!form.title.trim()) return setError("Title is required");
//     if (!form.message.trim()) return setError("Message is required");
//     if (form.send_type === "token" && !form.fcm_token.trim())
//       return setError("FCM Token is required for single device");

//     setLoading(true);
//     try {
//       if (initialData?._id) {
//         await updateNotification(initialData._id, form);
//       } else {
//         await createNotification(form);
//       }
//       await onSubmit();
//     } catch (err) {
//       setError(err?.response?.data?.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <div className="mb-6 flex items-center justify-between">
//         <h2 className="text-lg font-bold text-navy-700">
//           {initialData?._id ? "Edit Notification" : "Push Notification"}
//         </h2>
//         {/* <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
//           <MdClose size={22} />
//         </button> */}
//       </div>

//       <div className="max-w-lg space-y-4">
//         {/* <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Send To
//           </label>
//           <select
//             name="send_type"
//             value={form.send_type}
//             onChange={handleChange}
//             className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//           >
//             <option value="all">All Users</option>
//             <option value="token">Single Device (FCM Token)</option>
//           </select>
//         </div>

//         {form.send_type === "token" && (
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               FCM Token
//             </label>
//             <input
//               type="text"
//               name="fcm_token"
//               value={form.fcm_token}
//               onChange={handleChange}
//               placeholder="Enter device FCM token"
//               className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//             />
//           </div>
//         )} */}

//         <div>
//           <InputField
//             label=" Notification Title"
//             name="title"
//             value={form.title}
//             onChange={handleChange}
//             required
//           />
//           {/* <label className="block text-sm font-medium text-gray-700 mb-1">
//             Notification Title <span className="text-red-500">*</span>
//           </label>
//           <input
//             type="text"
//             name="title"
//             value={form.title}
//             onChange={handleChange}
//             placeholder="title"
//             className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//           /> */}
//         </div>

//         <div>
//           <TextareaField
//             label="Terms & Conditions"
//             name="message"
//             value={form.message}
//             onChange={handleChange}
//             placeholder="Enter message ..."
//             rows={3}
//             required
//           />
//           {/* <label className="mb-1 block text-sm font-medium text-gray-700">
//             Notification Message <span className="text-red-500">*</span>
//           </label>
//           <textarea
//             name="message"
//             value={form.message}
//             onChange={handleChange}
//             placeholder="message"
//             rows={4}
//             className="w-full resize-none rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//           /> */}
//         </div>

//         {error && <p className="text-sm text-red-500">{error}</p>}

//         <div className="flex gap-3 pt-2">
//           <button
//             onClick={handleSubmit}
//             disabled={loading}
//             className="btn-primary"
//           >
//             <MdSend size={16} />
//             {loading ? "Sending..." : initialData?._id ? "Update" : "Create"}
//           </button>
//           {/* <button
//             onClick={onClose}
//             className="px-5 py-2 border rounded-lg text-sm text-gray-600 hover:bg-gray-50"
//           >
//             Cancel
//           </button> */}
//         </div>
//       </div>
//     </div>
//   );
// }


import { useState, useRef } from "react";
import { InputField, SelectField, TextareaField } from "components/FormFields";
import Alert from "components/common/Alert";
import CustomButton from "components/CustomButton";

export default function BulkNotificationForm({ onSubmit, alert, setAlert }) {
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    send_type: "visitor", // Options: visitor | exhibitor | all
    is_scheduled: false,
    scheduled_at: "",
  });

  const alertRef = useRef(null);

  const audienceOptions = [
    { value: "visitor", label: "Visitors" },
    { value: "exhibitor", label: "Exhibitors" },
    { value: "all", label: "All Users" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.message.trim()) {
      setAlert("Please fill in all required fields.");
      return;
    }
    if (formData.is_scheduled && !formData.scheduled_at) {
      setAlert("Please select a valid schedule date and time.");
      return;
    }

    if (onSubmit) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      {alert && (
        <div ref={alertRef} className="px-1 pt-1">
          <Alert type="error" message={alert} onClose={() => setAlert("")} />
        </div>
      )}

      {/* Message Header / Title */}
      <InputField
        label="MESSAGE HEADER"
        name="title"
        value={formData.title}
        onChange={handleChange}
        placeholder="Enter message title..."
        required
      />

      {/* Content / Message Body */}
      <TextareaField
        label="CONTENT"
        name="message"
        value={formData.message}
        onChange={handleChange}
        placeholder="Write your notification message..."
        rows={3}
        required
      />

      {/* Audience Dropdown Target */}
      <SelectField
        label="SEND TO AUDIENCE"
        name="send_type"
        value={formData.send_type}
        onChange={handleChange}
        options={audienceOptions}
        required
      />

      {/* Schedule Switch & DateTime Selector */}
      {/* <div className="rounded-lg border border-gray-100 bg-gray-50/50 p-3.5 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">
            Schedule Message
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              name="is_scheduled"
              checked={formData.is_scheduled}
              onChange={handleChange}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#02a9e0]"></div>
          </label>
        </div>

        {formData.is_scheduled && (
          <InputField
            label="SCHEDULE DATE & TIME"
            name="scheduled_at"
            type="datetime-local"
            value={formData.scheduled_at}
            onChange={handleChange}
            required={formData.is_scheduled}
          />
        )}
      </div> */}

      <div className="mt-2 flex justify-end">
        <CustomButton
          label={formData.is_scheduled ? "Schedule Notification" : "Send Notification"}
          variant="solid"
          color="#02a9e0"
          type="submit"
        />
      </div>
    </form>
  );
}